import { ICardElementWithChildren } from "backend/model/model";

export const defaultSortFunction = (
  a: ICardElementWithChildren,
  b: ICardElementWithChildren
) => {
  return a.symbol.localeCompare(b.symbol);
};

export const resultSort = (list: ICardElementWithChildren[]) => {
  const res = list.sort(defaultSortFunction);
  res.forEach((item) => {
    if (item.children) {
      item.children = resultSort(item.children);
    }
  });
  return res;
};
